"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var mobx_1 = require("mobx");
var ProjectTypes_1 = require("../ProjectTypes");
var DeletedProjectStore = (function () {
    function DeletedProjectStore(projectData, projectApiService) {
        this.projectApiService = projectApiService;
        this._projectData = projectData;
    }
    Object.defineProperty(DeletedProjectStore.prototype, "type", {
        get: function () {
            return "DeletedProjectStore";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeletedProjectStore.prototype, "_id", {
        get: function () {
            return this._projectData._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeletedProjectStore.prototype, "name", {
        get: function () {
            return this._projectData.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeletedProjectStore.prototype, "user", {
        get: function () {
            return this._projectData.user;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeletedProjectStore.prototype, "tags", {
        get: function () {
            return lodash_1.default.uniq(this._projectData.tags);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeletedProjectStore.prototype, "userAction", {
        get: function () {
            return this._projectData.$userAction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DeletedProjectStore.prototype, "links", {
        get: function () {
            return this._projectData.links;
        },
        enumerable: false,
        configurable: true
    });
    DeletedProjectStore.prototype.restore = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2, this.projectApiService.restoreProjects([this._projectData._id])];
            });
        });
    };
    var _a, _b;
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], DeletedProjectStore.prototype, "_id", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], DeletedProjectStore.prototype, "name", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], DeletedProjectStore.prototype, "user", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], DeletedProjectStore.prototype, "tags", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], DeletedProjectStore.prototype, "userAction", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], DeletedProjectStore.prototype, "links", null);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_a = typeof ProjectTypes_1.IProject !== "undefined" && ProjectTypes_1.IProject) === "function" ? _a : Object)
    ], DeletedProjectStore.prototype, "_projectData", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], DeletedProjectStore.prototype, "restore", null);
    return DeletedProjectStore;
}());
exports.default = DeletedProjectStore;
